import { render, staticRenderFns } from "./r-search-input.vue?vue&type=template&id=61bbb5ae"
import script from "./r-search-input.vue?vue&type=script&lang=js"
export * from "./r-search-input.vue?vue&type=script&lang=js"
import style0 from "./r-search-input.vue?vue&type=style&index=0&id=61bbb5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./r-search-input.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports